/* ------------------------------------------------------------------ */
/*  Color palettes for tournament calendar                             */
/* ------------------------------------------------------------------ */

/** Card background colors – one per tournament (tournament_group_id). */
export const TOURNAMENT_COLORS = [
  { bg: "#E3F2FD", text: "#1565C0", border: "#1976D2" }, // Light blue
  { bg: "#F3E5F5", text: "#6A1B9A", border: "#7B1FA2" }, // Light purple
  { bg: "#E8F5E9", text: "#2E7D32", border: "#388E3C" }, // Light green
  { bg: "#FFF3E0", text: "#E65100", border: "#F57C00" }, // Light orange
  { bg: "#FCE4EC", text: "#C2185B", border: "#C2185B" }, // Light pink
  { bg: "#E0F2F1", text: "#00695C", border: "#00796B" }, // Light teal
  { bg: "#FFF9C4", text: "#F57F17", border: "#FBC02D" }, // Light yellow
  { bg: "#EFEBE9", text: "#5D4037", border: "#6D4C41" }, // Light brown
];

/** Chip colors – one per league (tournament_id). */
export const LEAGUE_CHIP_COLORS = [
  { bg: "#1976D2", text: "#FFFFFF" }, // Blue
  { bg: "#7B1FA2", text: "#FFFFFF" }, // Purple
  { bg: "#388E3C", text: "#FFFFFF" }, // Green
  { bg: "#F57C00", text: "#FFFFFF" }, // Orange
  { bg: "#C2185B", text: "#FFFFFF" }, // Pink
  { bg: "#00796B", text: "#FFFFFF" }, // Teal
  { bg: "#F9A825", text: "#333333" }, // Yellow
  { bg: "#5D4037", text: "#FFFFFF" }, // Brown
];

/** Returns card colour for a given tournament group. */
export function getColorForTournament(
  tournamentGroupId: number
): (typeof TOURNAMENT_COLORS)[0] {
  return TOURNAMENT_COLORS[tournamentGroupId % TOURNAMENT_COLORS.length];
}

/** Returns chip colour for a given league. */
export function getColorForLeagueChip(
  tournamentId: number
): (typeof LEAGUE_CHIP_COLORS)[0] {
  return LEAGUE_CHIP_COLORS[tournamentId % LEAGUE_CHIP_COLORS.length];
}

